import React, { useState, useEffect } from "react";
import { isAdmin } from "../api/controller/userType";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../assets/VRP.png";
import { RegionsCardData } from "../api/controller/videoController/regions";
import RegionDialog from "./DialogBoxes/RegionDialog";
import { getUserProfile } from "../api/controller/userProfile";
import linkedin from "../assets/linkedin-sales-solutions.jpg"
import Loader from "../components/Loader";



// City Card Component
const CityCard = ({ city }) => {
  return (
        <Link
      to={`/video-platform/regions/${city.city}/industries`}
      className="bg-white shadow w-full max-w-full h-[100px] overflow-hidden hover:shadow-lg hover:scale-105 transition-transform duration-300 mx-auto flex items-center justify-center text-center"
    >
            <div className="p-2">
        <h3 className="text-lg md:text-2xl sm:text-lg text-[#003DA5] font-bold font-['corporate-s'] flex items-center gap-2 justify-center">
          {city.city}
        </h3>
        </div>
    </Link>
    // <Link
    //   to={`/video-platform/regions/${city.city}/industries`}
    //   className="bg-white rounded-md shadow w-full max-w-[270px] h-[280px] sm:h-[300px] overflow-hidden hover:shadow-lg hover:scale-105 transition-transform duration-300 mx-auto"
    // >
    //   <img
    //     src={city.imageURL}
    //     className="h-[140px] sm:h-[150px] w-full object-cover"
    //     alt={city.city}
    //   />
    //   <div className="p-3 sm:p-4">
    //     <h3 className="text-lg sm:text-[20px] text-[#003DA5] font-semibold font-['corporate-s'] mb-2 sm:mb-3 flex items-center gap-2">
    //       <FaMapMarkerAlt className="text-[#003DA5]" size={14} />
    //       {city.city}
    //     </h3>
    //     <div className="flex items-center gap-2 font-semibold text-[#00244D] font-['corporate-s'] text-sm sm:text-[14px]">
    //       <FaIndustry className="text-[#003DA5]" size={14} /> Industries:{" "}
    //       <span className="text-gray-500">{city.industries}</span>
    //     </div>
    //     <div className="flex items-center text-[#00244D] gap-2 font-semibold text-sm sm:text-[14px] font-['corporate-s']">
    //       <FaUsers className="text-[#003DA5]" size={14} /> Individuals:{" "}
    //       <span className="text-gray-500">{city.individuals}</span>
    //     </div>
    //   </div>
    // </Link>
  );
};

// Regions Page
const Regions = () => {
  const navigate = useNavigate();
  const [regions, setRegions] = useState([]);
  const regionSearch = "";
  const [showRegionDialog, setShowRegionDialog] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoadingRegions, setIsLoadingRegions] = useState(false);

  useEffect(() => {
    async function fetchUserProfile() {
      try {
        const userProfile = await getUserProfile();
        setUser(userProfile);
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
        setUser(null);
      }
    }
    fetchUserProfile();
  }, []);

  useEffect(() => {
    if (user) {
      const fetchRegions = async () => {
        try {
          setIsLoadingRegions(true);
          const data = await RegionsCardData();
          setRegions(data);
        } catch (error) {
          console.error("Error fetching regions:", error);
        } finally {
          setIsLoadingRegions(false);
        }
      };
      fetchRegions();
    }
  }, [user]);

  const createRegion = (newRegion) => {
    setRegions((prev) => [...prev, newRegion]);
  };

  const filteredRegions = React.useMemo(
    () =>
      regions.filter(
        (city) =>
          city.city?.toLowerCase().includes(regionSearch.toLowerCase()) ||
          city.state?.toLowerCase().includes(regionSearch.toLowerCase())
      ),
    [regionSearch, regions]
  );

  const groupedByState = React.useMemo(
    () =>
      filteredRegions.reduce((acc, city) => {
        if (!acc[city.state]) acc[city.state] = [];
        acc[city.state].push(city);
        return acc;
      }, {}),
    [filteredRegions]
  );

  if (!user) {

        return (
      <div className="min-h-screen  font-['corporate-s']">
                        <div className="relative">
                        <img
                          src={Logo}
                          alt="Video Resume Platform"
                          className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover"
                        />
         <div className="absolute inset-0 flex items-center justify-center p-4">
    </div>
  </div>
        {/* Main Content Container (Centered with space on sides) */}
      <main className="max-w-7xl mx-auto mt-8 md:px-20 px-6">
        
      
        {/* This div is the container for the image with space around it */}
        <div className="relative">
          <div className="bg-white shadow-xl overflow-hidden border border-gray-200">
                        <div className="relative">
                        <img
                          src={linkedin}
                          alt="Video Resume Platform"
                          className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover"
                        />
                        </div>
          </div>
        </div>

        {/* Section 1: Employer Login (1/3rd) and Main Paragraph (2/3rd) side-by-side */}
        <div className="flex flex-col md:flex-row mb-12">
          {/* Left Column (1/3rd width on medium screens+) */}
          <div className="w-full md:w-[40%]">
            <div className="bg-yellow-400 md:px-20 px-10 py-4 items-center shadow-lg h-full flex flex-col justify-center">
              <h3 className="text-xl md:text-3xl font-bold text-[#fff] font-['farnham-display'] leading-relaxed">New
               or <br /> Existing Employer</h3>
            <button
              onClick={() => navigate("/login")}
              className="bg-[#003DA5] px-6 sm:px-8 py-3 my-2 sm:py-4 cursor-pointer text-[#fff] font-semibold text-xl sm:text-lg w-full"
              aria-label="Log in or create an account to access content"
            >
              Create Account/ Login
            </button>
            </div>
          </div>

          {/* Right Column (2/3rd width on medium screens+) */}
          <div className="w-full md:w-2/3">
            {/* Blue informational text banner */}
            <div className="bg-[#003DA5] text-white md:px-16 md:py-4 px-8 shadow-lg h-full flex items-center">
              <p className="text-xl py-2 md:text-3xl text-[#fff] font-bold font-['farnham-display'] leading-relaxed">
                Faces of Talent is a video resume portal designed to connect employers with qualified justice-involved individuals and create a robust workforce.
              </p>
            </div>
          </div>
        </div>
        
        {/* Why Video Resumes? */}
        {/* We use a grid here to ensure the vertical alignment requested by the user */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
            {/* Left Column Title (Aligned with the yellow box above) */}
            <div className="md:col-span-1 flex items-center justify-center">
                <h1 className="text-xl md:text-3xl font-bold font-['farnham-display'] leading-relaxed text-[#668ac9]">Why Video Resumes?</h1>
            </div>
            
            {/* Right Column Content (Aligned with the blue text block above) */}
            <div className="bg-[#f0f0f0] md:col-span-2 pl-6 w-full mt-6 md:w-full relative p-6 sm:p-6">
              {/* Yellow Line */}
              <div className="border-l-6  border-[#FFC72C] ml-3">
                {/* Content */}
                <div className=" font-['corporate-s'] pl-6 md:mr-18 text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed">
                  <p>
                    Our VRP gives justice-involved job seekers the chance to introduce 
                    themselves beyond the traditional paper resume. 
                    <br/>
                    Each resume is, 2-3 minute professional introduction video, where 
                    candidates showcase their: Work readiness, Personality and motivation, and 
                    their commitment to personal and professional growth
                  </p>
                </div>
              </div>
            </div>
        </div>

        {/*How Employers Benefit (Full width below the above section) */}
        <section className="mb-12 pt-8">
          <h1 className="text-xl md:text-3xl mb-6 font-bold font-['farnham-display'] leading-relaxed text-[#668ac9] md:text-left text-center">How Employers Benefit</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Benefit Cards (using the structure from the previous example) */}
            <div className="border-t-4 border-yellow-400 pt-4 p-4 bg-white shadow-lg ">
              <h3 className="font-bold text-2xl text-[#668ac9] mb-2">Vetted Candidates</h3>
              <p className="md:text-lg text-md lg:text-lg text-gray-600" >Employers across Missouri gain access, to a vetted,
                motivated workforce from our four regions 
                across the state.
                </p>
            </div>
            <div className="border-t-4 border-yellow-400 pt-4 p-4 bg-white shadow-lg">
              <h3 className="font-bold text-2xl text-[#668ac9]  mb-2">Support of SLU TWA</h3>
              <p className="md:text-lg text-md lg:text-lg text-gray-600">Employers will have access to support from a SLU TWA professional, 
                in addition to other resources.</p>
            </div>
            <div className="border-t-4 border-yellow-400 pt-4 p-4 bg-white shadow-lg">
              <h3 className="font-bold text-2xl text-[#668ac9]  mb-2">24/7 Talent Access</h3>
              <p className="md:text-lg text-md lg:text-lg text-gray-600">Gain full access to the Faces of 
                Talent Portal and the range of skillsets available whenever your 
                organization is in need</p>
            </div>
            <div className="border-t-4 border-yellow-400 pt-4 p-4 bg-white shadow-lg">
              <h3 className="font-bold text-2xl text-[#668ac9]  mb-2">Informed Hiring</h3>
              <p className="md:text-lg text-md lg:text-lg text-gray-600">Employers will make informed, 
                inclusive hiring decisions that 
                strengthen their teams and communities</p>
            </div>
          </div>
        </section>
        </main>
              </div> 
    );
  }

    return (

    <div className="min-h-screen bg-white">

                <div className="relative">
                        <img
                          src={Logo}
                          alt="Video Resume Platform"
                          className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover"
                        />
         <div className="absolute inset-0 flex items-center justify-center p-4">
    </div>
  </div>

      {/* Main Content Section - Region Selection */}
      <main className="max-w-4xl mx-auto p-4 md:p-8">
        <div className="bg-yellow-400 p-6 md:p-8 shadow-lg">
          <h2 className="text-center text-3xl font-bold text-[#fff] uppercase tracking-wider mb-2">
            Click on your region
          </h2>
          <p className="text-center text-md text-[#003DA5] mb-6">
            SLU TWA is strategically located in 4 region across the State of Missouri.
          </p>
            
<div className="flex flex-col sm:flex-row sm:justify-end sm:items-center gap-4 mb-4 sm:mb-6">
            {isAdmin() && (
              <button
                onClick={() => setShowRegionDialog(true)}
                className="bg-[#00244D] text-white px-4 py-2 rounded-lg shadow-lg hover:bg-[#001F3D] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 w-full sm:w-auto text-sm"
                title="Add Region"
              >
                Add Region
              </button>
            )}
          </div>
          {isLoadingRegions ? (
            <div className="flex justify-center items-center py-16">
              <Loader label="Loading regions..." size={56} className="flex-col gap-5 text-[#003DA5]" />
            </div>
          ) : (
            <>
              {groupedByState && Object.entries(groupedByState).map(([state, cities]) => (
                <div key={state} className="mb-6 sm:mb-8">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mt-4 sm:mt-6">
                    {cities.map((city, index) => (
                      <CityCard key={`${city.cityId}-${index}`} city={city} />
                    ))}
                  </div>
                  <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 mt-4 sm:mt-6">
                    <span className="text-[#00244D] font-['corporate-s'] text-sm sm:text-[16px]">
                      Know a candidate? Search with the name
                    </span>
                    <button
                      onClick={() => navigate("/video-platform/videos")}
                      className="border-2 border-[#00244D] text-[#00244D] bg-transparent px-4 py-2 rounded-lg font-['corporate-s'] hover:bg-[#00244D] hover:text-white transition-colors text-sm sm:text-base"
                    >
                      Search
                    </button>
                  </div>
                </div>
              ))}
              {filteredRegions.length === 0 && (
                <p className="text-center text-gray-600 mt-6 sm:mt-8 text-sm sm:text-base">
                  No regions found.
                </p>
              )}
            </>
          )}

      <RegionDialog
        showModal={showRegionDialog}
        setShowModal={setShowRegionDialog}
        onCreateRegion={createRegion}
      />
        </div>
      </main>

      {/* Footer Section */}
      <div aria-label="Footer-section" className="bg-[#668ac9] mt-16">
        <div className="max-w-6xl mx-auto py-6 text-left md:text-center text-[#FFC27C] p-4">
          <p className="text-2xl font-medium font-['farnham-display']">
            Together, we can invest in second chances and stronger communities.
          </p>
        </div>
      </div>
</div>

  );
};

export default Regions;




  //   return (
  //     <div className="min-h-screen bg-gray-100 font-['Crimson_Pro'] px-4 sm:px-6 py-6">
  //       <div className="max-w-7xl mx-auto flex flex-col lg:flex-row">
  //         {/* 3/4 Layout */}
  //         <div className="w-full lg:w-3/4 bg-white shadow p-4 sm:p-6">
  //           <img
  //             src={Logo}
  //             alt="Video Resume Platform"
  //             className="w-full object-contain rounded-md mb-4"
  //           />
  //           <h2 className="text-xl w-[90%] font-bold mx-auto sm:text-xl lg:text-2xl font-['Crimson_Pro'] text-[#FFC72C] mb-6 text-center">
  //             A tool specifically designed to connect employers
  //             <br /> with qualified justice-involved individuals and create a
  //             robust workforce.
  //           </h2>
  //           <div className="flex flex-col sm:flex-row gap-4">
  //             <div className="w-full sm:w-1/2">
  //               <h3 className="text-lg sm:text-xl font-['HVD_Trial_Brandon_Grotesque'] font-bold text-[#003DA5] mb-2">
  //                 WHY VIDEO RESUMES
  //               </h3>
  //               <p className="text-md sm:text-base font-['corporate-s']">
  //                 Our VRP gives justice-involved job seekers the chance to
  //                 introduce themselves beyond the traditional paper resume.
  //               </p>
  //               <p className="text-sm sm:text-base font-['corporate-s'] my-4">
  //                 Each resume is a 2-3 minute professional introduction video,
  //                 where candidates showcase their
  //               </p>
  //               <p className="text-sm sm:text-base font-['corporate-s']">
  //                 Work readiness
  //               </p>
  //               <p className="text-sm sm:text-base font-['corporate-s']">
  //                 Personality and motivation
  //               </p>
  //               <p className="text-sm sm:text-base font-['corporate-s']">
  //                 Commitment to personal and professional growth
  //               </p>
  //             </div>
  //             <div className="w-full sm:w-1/2">
  //               <h3 className="text-lg sm:text-xl font-['HVD_Trial_Brandon_Grotesque'] font-bold text-[#003DA5] mb-2">
  //                 HOW EMPLOYERS BENEFIT
  //               </h3>
  //               <p className="text-sm sm:text-base font-['corporate-s']">
  //                 Employers across Missouri gain access to a vetted, motivated
  //                 workforce from four regions across the state.
  //                 <p className="text-sm sm:text-base font-['corporate-s'] my-4">
  //                   Expand networks and collaborate with reentry partners to
  //                   support second-chance hiring goals.
  //                 </p>
  //                 <p className="text-sm sm:text-base font-['corporate-s']">
  //                   Make informed, inclusive hiring decisions that strengthen
  //                   their teams and communities.
  //                 </p>
  //               </p>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="w-full text-white lg:w-[30%] bg-[#FFC72C] shadow px-6 py-10 sm:px-8 sm:py-12 flex flex-col justify-between">
  //           <div>
  //             <h3 className="text-4xl font-bold sm:text-xl font-['HVD_Trial_Brandon_Grotesque'] mb-4">
  //               STEPS TO GET STARTED
  //             </h3>

  //             <span className="block font-2xl font-bold sm:text-xl font-['HVD_Trial_Brandon_Grotesque'] mb-2">
  //               FIRST
  //             </span>
  //             <p className="text-lg sm:text-base font-['corporate-s'] mb-6">
  //               Create your professional profile. Once the profile is created,
  //               you will gain access to the VRP.
  //             </p>

  //             <span className="block font-2xl font-bold sm:text-xl font-['HVD_Trial_Brandon_Grotesque'] mb-2">
  //               NEXT
  //             </span>
  //             <p className="text-lg sm:text-base font-['corporate-s'] mb-6">
  //               Select your region(s) and industry.
  //             </p>

  //             <span className="block font-2xl font-bold sm:text-xl font-['HVD_Trial_Brandon_Grotesque'] mb-2">
  //               THEN
  //             </span>
  //             <p className="text-lg sm:text-base font-['corporate-s'] mb-6">
  //               Review the candidate videos, or narrow down your search by
  //               utilizing the filters for offense exemptions, transportation,
  //               skill searching, or even by candidate name.
  //             </p>

  //             <span className="block font-2xl font-bold sm:text-xl font-['HVD_Trial_Brandon_Grotesque'] mb-2">
  //               LAST
  //             </span>
  //             <p className="text-lg sm:text-base font-['corporate-s'] mb-8">
  //               Narrow down your talent search and CONNECT!! Direct contact
  //               information for each candidate is accessible on the written
  //               resume, which is downloadable!
  //             </p>
  //           </div>

  //           <button
  //             onClick={() => navigate("/login")}
  //             className="bg-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg cursor-pointer font-['HVD_Trial_Brandon_Grotesque'] text-[#00244D] text-md sm:text-base w-full"
  //             aria-label="Log in or create an account to access content"
  //           >
  //             Login/Create Account
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // return (
  //   <div className="font-['Crimson_Pro']">
  //     <section className="bg-gray-100 py-6 px-4 sm:px-6 lg:px-8 min-h-screen">
  //       <div className="flex flex-col items-center py-8 sm:py-12 px-4 sm:px-6">
  //         <h2 className="text-2xl sm:text-3xl lg:text-4xl font-normal font-['Crimson_Pro'] text-[#00244D] text-center">
  //           Video Resume Platform
  //         </h2>
  //         <p className="mt-4 sm:mt-6 text-sm sm:text-base font-['corporate-s'] text-left max-w-3xl">
  //           At SLU’s Transformative Workforce Academy (TWA), video-based resumes
  //           are transforming the way justice-involved jobseekers connect with
  //           employers. By giving applicants the chance to share their story,
  //           experience, and motivation directly through video, TWA helps
  //           employers see beyond criminal records to the person’s potential.
  //           Harnessing this platform, candidates can craft a 1–2 minute pitch,
  //           highlighting skills, goals, and growth bridging barriers and
  //           fostering authentic connections. The Video Resume Platform is
  //           central to TWA’s mission of expanding fair-chance employment and
  //           reducing recidivism.
  //         </p>
  //       </div>
  //       <div className="max-w-7xl mx-auto text-center">
  //         <h2 className="text-2xl sm:text-3xl lg:text-3xl font-normal font-['Crimson_Pro'] text-[#003DA5] mb-4 sm:mb-6 text-center">
  //           Together, we can invest in second chances and stronger communities.
  //         </h2>
  //         <p className="text-base sm:text-md lg:text-md leading-relaxed mb-6 sm:mb-8 font-['corporate-s']">
  //           TWA serves multiple communities across Missouri. Click on a location
  //           to reach out to the local contact.
  //         </p>
  //         <div className="flex justify-center mb-4">
  //           <h2 className="text-xl sm:text-2xl lg:text-3xl font-['Crimson_Pro'] text-[#003DA5] text-center">
  //             Missouri
  //           </h2>
  //         </div>
  //         <div className="flex flex-col sm:flex-row sm:justify-end sm:items-center gap-4 mb-4 sm:mb-6">
  //           {isAdmin() && (
  //             <button
  //               onClick={() => setShowRegionDialog(true)}
  //               className="bg-[#00244D] text-white px-4 py-2 rounded-lg shadow-lg hover:bg-[#001F3D] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 w-full sm:w-auto text-sm"
  //               title="Add Region"
  //             >
  //               Add Region
  //             </button>
  //           )}
  //         </div>
  //         {Object.entries(groupedByState).map(([state, cities]) => (
  //           <div key={state} className="mb-6 sm:mb-8">
  //             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mt-4 sm:mt-6">
  //               {cities.map((city, index) => (
  //                 <CityCard key={`${city.cityId}-${index}`} city={city} />
  //               ))}
  //             </div>
  //             <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 mt-4 sm:mt-6">
  //               <span className="text-[#00244D] font-['corporate-s'] text-sm sm:text-[16px]">
  //                 Know a candidate? Search with the name
  //               </span>
  //               <button
  //                 onClick={() => navigate("/video-platform/videos")}
  //                 className="border-2 border-[#00244D] text-[#00244D] bg-transparent px-4 py-2 rounded-lg font-['HVD_Trial_Brandon_Grotesque'] hover:bg-[#00244D] hover:text-white transition-colors text-sm sm:text-base"
  //               >
  //                 Search
  //               </button>
  //             </div>
  //           </div>
  //         ))}
  //         {filteredRegions.length === 0 && (
  //           <p className="text-center text-gray-600 mt-6 sm:mt-8 text-sm sm:text-base">
  //             No regions found.
  //           </p>
  //         )}
  //       </div>
  //     </section>
  //     <RegionDialog
  //       showModal={showRegionDialog}
  //       setShowModal={setShowRegionDialog}
  //       onCreateRegion={createRegion}
  //     />
  //   </div>
  // );
// };

// export default Regions;
